import SafeHtml from '../../safeHtml';
import { WithCoreProps, CoreHelper } from 'ff-shared-components-core';

import * as React from 'react';
import parse from 'html-react-parser';
import { Theme } from '../../../../../theme/types';
import { styled } from '../../../../../theme';
import defaultTheme from '../../../../../theme/defaultTheme';

interface JourneyLabelProps {
	/** set the text */
	text?: string | JSX.Element | null;
	/** set the size */
	size?: string;
	/** set the label that contains html  */
	html?: boolean;
	/** set at center */
	center?: boolean;
	/** set label to have id1 font and size */
	id1?: boolean;
	/** set label to have id2 font and size */
	id2?: boolean;
	/** set label to have id3 font and size */
	id3?: boolean;
	/** set label to have id4 font and size */
	id4?: boolean;
	/** set label to have id5 font and size */
	id5?: boolean;
	/** set label to have id6 font and size */
	id6?: boolean;
	/** set label to have id7 font and size */
	id7?: boolean;
	/** set label to have id8 font and size */
	id8?: boolean;
	/** set label to have id9 font and size */
	id9?: boolean;
	/** set label to have id10 font and size */
	id10?: boolean;
	/** set label to have id11 font and size */
	id11?: boolean;
	/** set label to have id12 font and size */
	id12?: boolean;
	/** set label to have id13 font and size */
	id13?: boolean;
	/** set label to have id14 font and size */
	id14?: boolean;
	/** set label to have id15 font and size */
	id15?: boolean;
	/** set label to have id16 font and size */
	id16?: boolean;
	/** set label to have id17 font and size */
	id17?: boolean;
	/** set label to have id19 font and size */
	id19?: boolean;
	/** set label to have id20 font and size */
	id20?: boolean;
	/** set label to have id21 font and size */
	id21?: boolean;
	/** set label to have id22 font and size */
	id22?: boolean;
	/** set to label have padding left */
	paddingLeft?: boolean;
	/** set to label have padding right */
	paddingRight?: boolean;
	/** set to label have light color */
	lightColor?: boolean;
	/** set label height */
	height?: number;
	/** set label color */
	color?: string;
}

interface InjectedProps {
	theme: Theme;
}

interface JourneyLabelStyleProps extends JourneyLabelProps {
	theme: Theme;
	color?: string;
}

// cSpell: disable
const Label = styled.label`
	font-size: ${(props: JourneyLabelStyleProps) => props.size};
`;

const JourneyLabel = (props: JourneyLabelProps & InjectedProps) => {
	const { text, center, size, height, html, theme: propsTheme } = props;
	const theme = CoreHelper.mergeObjects(defaultTheme, propsTheme);

	let fontsize = '14px';

	if (size) {
		fontsize = size;
	}
	const content = html ? <SafeHtml html={text} /> : text;
	return (
		<Label size={fontsize} height={height} center={center} {...props} theme={theme}>
			{typeof content === 'string' ? parse(content) : content}
		</Label>
	);
};
// cSpell: enable
export default WithCoreProps<JourneyLabelProps>(JourneyLabel);
